import DollarIcon from "Images/quiz/dollar_icon.svg";
import CakeIcon from "Images/quiz/cake_icon.svg";
import Review from "Images/quiz/review_icon.svg";
import NPS from "Images/quiz/nps.svg";
import RD from "Images/quiz/rd.svg";
import Friend from "Images/quiz/friend.svg";
import Facebook from "Images/quiz/fb.svg";
import Instagram from "Images/quiz/instagram.svg";
import Tiktok from "Images/quiz/tiktok.svg";
import Discord from "Images/quiz/discord.svg";
import FirstResponderIcon from "Images/quiz/FirstResponder.svg";
import MilitaryIcon from "Images/quiz/Military.svg";
import StudentIcon from "Images/quiz/Student.svg";
import HealthcareWorkerIcon from "Images/quiz/HealthcareWorker.svg";
//
import Silver from "Images/quiz/tier/silver.svg";
import Gold from "Images/quiz/tier/gold.svg";
import Platinum from "Images/quiz/tier/platinum.svg";
export const howItWorksStepsData = [
    {
        step: "01",
        title: "Join gainful",
        subtitle: "Join Gainful and you’ll automatically start earning points for every order.",
    },
    {
        step: "02",
        title: "earn points",
        subtitle: "points with every purchase, referral, and special actions.",
    },
    {
        step: "03",
        title: "Redeem",
        subtitle: "to save money on future orders. Once you hit 100 points, click above or visit your subscription tab to apply savings.",
    },
];
export const howToEarnData = [
    {
        title: "1 Point",
        subtitle: "per dollar spent.",
        icon: DollarIcon,
        note: "(psst: higher tiers = more points per $ spent)",
        hideBackward: true,
        key: "point",
    },
    {
        title: "100 Points",
        subtitle: "on your birthday",
        icon: CakeIcon,
        isBirthday: true,
        btnLabel: "Save",
        key: "birthday",
    },
    {
        title: "75 Points",
        subtitle: "when you leave a review",
        hoverCopy: "You'll receive an email ~2 weeks after your order. You'll get 75 points for each new product you review.",
        icon: Review,
        key: "review",
    },
    {
        title: "75 Points",
        subtitle: "when you let us know how we are doing",
        icon: NPS,
        hoverCopy: "Earn 75 points once you complete our 1 question survey ",
        link: "https://gainful.typeform.com/to/ZLBN3a#email={email}&fname={fname}&source=rewards",
        btnLabel: "Complete Survey",
        key: "nps",
    },
    {
        title: "75 Points",
        subtitle: "when you complete a Registered Dietitian check-in questionnaire",
        icon: RD,
        hoverCopy: "Earn 75 points when you complete a check-in",
        btnLabel: "Complete Survey",
        link: "/quiz-new/quiz_rd/",
        key: "rd_check_in",
    },
    {
        title: "600 Points",
        subtitle: "when you refer a friend",
        icon: Friend,
        hoverCopy: "Earn 600 points when you refer a friend",
        btnLabel: "refer a friend",
        referFriend: true,
        key: "refer",
    },
    {
        title: "10 Points",
        subtitle: "when you follow us on Facebook",
        icon: Facebook,
        hoverCopy: "Earn 10 points when you follow us on Facebook",
        btnLabel: "Follow US",
        name: "facebook",
        link: "http://facebook.com/Gainful/",
        key: "facebook",
    },
    {
        title: "10 Points",
        subtitle: "when you follow us on Instagram",
        icon: Instagram,
        hoverCopy: "Earn 10 points when you follow us on Instagram",
        btnLabel: "Follow US",
        name: "instagram",
        link: "https://www.instagram.com/gainful/",
        key: "instagram",
    },
    {
        title: "10 Points",
        subtitle: "when you follow us on TikTok",
        icon: Tiktok,
        hoverCopy: "Earn 10 points when you follow us on TikTok",
        btnLabel: "Follow US",
        name: "tiktok",
        link: "http://tiktok.com/@gogainful",
        key: "tiktok",
    },
    {
        title: "50 Points",
        subtitle: "when you sign up for SMS",
        icon: NPS,
        hoverCopy: "Earn 50 points when you sign up for SMS",
        btnLabel: "Sign Up FOR sms US",
        name: "sms",
        key: "sms",
        link: "https://www.gainful.com/joinsms/",
    },
    {
        title: "20 Points",
        subtitle: "when you join our Facebook Community Group",
        icon: Facebook,
        hoverCopy: "Earn 20 points when you join our Facebook Community Group",
        btnLabel: "Join US",
        name: "facebook_community",
        link: "https://www.facebook.com/groups/gainfulcommunity",
        key: "facebook_community",
    },
    {
        title: "20 Points",
        subtitle: "when you join us on Discord",
        icon: Discord,
        hoverCopy: "Earn 20 points when you join us on Discord",
        btnLabel: "Join US",
        name: "discord",
        link: "https://discord.gg/qpk4ZKP6Xr",
        key: "discord",
    },
    {
        title: "10 Points",
        subtitle: "when you submit a question to your R.D",
        icon: DollarIcon,
        note: "(can be redeemed 1x/month)",
        hoverCopy: "Earn 10 points when you submit a question to your Registered Dietitian",
        btnLabel: "Contact RD",
        link: "/app/dietitian/",
        key: "rd_contact",
    },
];
export const tiersData = [
    {
        title: "Silver Tier",
        icon: Silver,
        subtitle: "$1-$349 spent",
        advantages: ["1 point per $1 spent", "Exclusive sales"],
        name: "silver",
    },
    {
        title: "Gold Tier",
        icon: Gold,
        subtitle: "$350-$749 spent",
        advantages: ["1.5 points per $1 spent", "50 points upon entry", "Exclusive sales"],
        name: "gold",
    },
    {
        title: "Platinum Tier",
        icon: Platinum,
        subtitle: "$750+ spent",
        advantages: ["2 points per $1 spent", "100 points upon entry", "Exclusive sales"],
        name: "platinum",
    },
];
export const tierVerificationData = [
    {
        title: "Students",
        link: "https://services.sheerid.com/verify/611e61e594362b75f495bd27/",
        icon: StudentIcon,
    },
    {
        title: "Military",
        link: "https://services.sheerid.com/verify/615f3567aeca3724dc9e9f49/",
        icon: MilitaryIcon,
    },
    {
        title: "Healthcare Workers",
        link: "https://services.sheerid.com/verify/623b827ebdf96328093ef9ea/",
        icon: HealthcareWorkerIcon,
    },
    {
        title: "First Responders",
        link: "https://services.sheerid.com/verify/623b80aebdf96328093ee0b3/",
        icon: FirstResponderIcon,
    },
];
export const rewardsFAQData = [
    {
        title: "When I upgrade to a new tier, do all rewards program actions become more valuable?",
        text: "No. Tier status only impacts the number of points acquired through dollars spent. Other rewards program actions (e.g. referrals, social follows) do not increase in value.",
    },
    {
        title: "How do I redeem points?",
        text: "Once you log in, you can simply click “Redeem Points” above, or in your profile, and choose how many you’d like to apply to your next order. ",
    },
    {
        title: "Are there rules for how many points I can redeem at once?",
        text: "Yes. Once you’ve acquired 100 or more points, you can redeem them in blocks of 100. When eligible, you get to choose how many blocks of points you use on a given order, limited to 400 points per order.",
    },
    {
        title: "Can I stack rewards points and other promotional discounts?",
        text: "Yes. Subscribers may stack rewards points and additional discounts when explicitly stated.",
    },
    {
        title: "How do referrals work?",
        text: "You invite your friend using your unique invite link. Once they subscribe using that link, 600 points are added to your account. Your friend (i.e. referee) will receive a promo code for 40% off their first order. (Max $40 discount)",
    },
    {
        title: "Do points expire?",
        text: "Yes. Points expire on 12/31/23. Also, if you cancel your account, your points will expire.",
    },
    {
        title: "Can I transfer points?",
        text: "No. Points cannot be transferred or redeemed on another account.",
    },
    {
        title: "Can I get points for submitting multiple reviews?",
        text: "You get points for each new product review you submit, but you can only submit one review per product you purchase. You do not get rewards points for submitting service-only reviews after Customer Support or Registered Dietitian interactions.",
    },
    {
        title: "Can I earn points on Gainful at Target purchases?",
        text: "Right now, Gainful rewards are earned on purchases at Gainful.com only.",
    },
];
